import { JWT } from '../constants/local_storage'
import { scopePreviewStorage } from './scopePreviewStorage'

// localStorage's own `storage` event only reaches other tabs, so writes announce
// themselves in-tab through this event as well.
export const JWT_CHANGE_EVENT = 'jwtChange'

function read(): string | null {
  try {
    return localStorage.getItem(JWT)
  } catch (e) {
    console.error('[jwtStorage] Failed to read', e)
    return null
  }
}

function write(token: string): void {
  try {
    // A preview belongs to the session that set it; login is the only writer
    scopePreviewStorage.clear()
    localStorage.setItem(JWT, token)
    window.dispatchEvent(new Event(JWT_CHANGE_EVENT))
  } catch (e) {
    console.error('[jwtStorage] Failed to write', e)
  }
}

function clear(): void {
  try {
    scopePreviewStorage.clear()
    localStorage.removeItem(JWT)
    window.dispatchEvent(new Event(JWT_CHANGE_EVENT))
  } catch (e) {
    console.error('[jwtStorage] Failed to clear', e)
  }
}

export const jwtStorage = { get: read, set: write, remove: clear }
